export default __webpack_public_path__ + "static/media/misc-books1-480w.6e8c2796.webp";